import {useState} from 'react';
import Start from './Pages/Start';
import Contact from './Pages/Contact';
import Products from './Pages/Products';
import TopNavigation from './Pages/TopNavigation';

const Tour=()=>{
  const [x,setX]=useState(0);
  const [finished,setFinished]=useState(false);

  window.barSize=0.05;

  function navigate(to){
    let id=setInterval(frame,5);
    function frame(){
      setX(prev=>{
        if(to=='Products'){
          if(prev<100){
            return prev+5;
          }
          else if(prev>100){
            return prev-5;
          }
          else{
            clearInterval(id)
            return 100;
          }
        }
        if(to=='Contact'){
          if(prev<200){
            return prev+5;
          }
          else{
            clearInterval(id)
            return 200;
          }
        }
        if(to=='Start'){
          if(prev>0){
            return prev-5;
          }
          else{
            clearInterval(id);
            setFinished(true)
            return 0;
          }
        }
      })
    }
  }

  return(

    <div style={{width:'100%',height:'100%'}}>
      <div style={{position:'absolute',width:'100%',height:window.innerHeight*(1-window.barSize),left:`${-x}%`}}>
        <Start/>
      </div>
      <div style={{position:'absolute',width:'100%',height:window.innerHeight*(1-window.barSize),left:`${100-x}%`}}>
        {finished||x>0?
          <Products/>
        :null}
      </div>
      <div style={{position:'absolute',width:'100%',height:window.innerHeight*(1-window.barSize),left:`${200-x}%`}}>
        {finished||x>100?
          <Contact/>
        :null}
      </div>
      {!finished?
      <button
      onClick={()=>{navigate(x==0?'Products':x==100?'Contact':'Start')}}
      style={{zIndex:1,display:'flex',position:'absolute',height:window.innerHeight*(window.barSize),bottom:0,left:0,right:0}}>
        <img
        style={{width:window.innerHeight*(window.barSize-0.02),background:0}}
        src={require('../Assets/ArrowIcon.png')}/>
      </button>
      :
      <TopNavigation navigate={navigate} x={x}/>
      }
    </div>

  );

}

export default Tour;
